import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { moduloPerform } from '../../diccionarios/performValuesModulo';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class MantenedorProductoSpecsService {

  tvcModulo: any = {};
  urlIndustrias: any = {};
  url: string;

  constructor(
    private _util: UtilsService,
    private _commom: CommonService,
    private http: HttpClient
  ) {
    this.tvcModulo = moduloPerform;
    this.urlIndustrias = this.tvcModulo.url.productoSpecs;
    this.url = this._util.getUrlIoIndustrias();
  }

  getAllOrdenProductos() {
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base);
  }

  crearProductoSpecs(innObjPlc: any) {
    return this._commom.peticionPostConHeader(this.url + this.urlIndustrias.base, innObjPlc);
  }


  editarProductoSpecs(innObjPlc: any) {
    return this._commom.peticionPutConHeader(this.url + this.urlIndustrias.base, innObjPlc);
  }

  buscarProductoSpecs(idMaterial:string){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base + `/${idMaterial}`);
  }

  buscarProductoLineaSpecs(idMaterial:any,idLinea:string){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base + `/${idMaterial}/${idLinea}`);
  }

  buscarMaterialPresentacion(idMaterial:string){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base + `/material-presentacion/${idMaterial}`);
  }

  buscarbyIdLinea(idLinea:string){
    return this._commom.peticionGetConHeader(this.url + this.urlIndustrias.base + `/linea/${idLinea}`);
  }

  updateRegistro(innObjPlc: any) {
    return this._commom.peticionPutConHeader(this.url + this.urlIndustrias.base, innObjPlc);
  }

  deleteRegistro(idMaterial: string,idLinea: string) {
    return this._commom.peticionDeleteConHeader(this.url + this.urlIndustrias.base + `/${idMaterial}/${idLinea}`);
  }

  
}
